import { ICountry } from '../../interfaces';

const determineZipCodeLabel = (countries: ICountry[], countryCode: string): string => {
  const currentCountry: ICountry | undefined = countries.find(
    (country) => country.countryCode.toLowerCase() === countryCode.toLowerCase()
  );
  if (!currentCountry) return 'Zip Code';
  return currentCountry.labels.zip_code;
};

export { determineZipCodeLabel };
